// Dynamic styles based on theme - to be used with useThemedStyles.
// Shared by the pending stock resolve and scan-excess dialogs.
export const createPendingStockDialogStyles = ({ ui: { colors, type, space } }) => ({
	dialogContainer: {
		maxHeight: '82%',
	},
	dialogScroll: {
		flexGrow: 0,
	},
	dialogContent: {
		paddingBottom: space.sm,
	},
	dialogTitle: {
		...type.cardTitle,
		color: colors.text,
		marginBottom: space.sm,
		paddingRight: space.xxl,
	},
	dialogMeta: {
		...type.bodySmall,
		color: colors.textSecondary,
		marginBottom: space.sm,
	},
	warningText: {
		...type.bodySmallSemibold,
		color: colors.warning,
		marginTop: space.sm,
		marginBottom: space.xs,
	},
	errorText: {
		...type.bodySmallSemibold,
		color: colors.danger,
		marginTop: space.sm,
		marginBottom: space.xs,
	},
	dialogActions: {
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: space.sm,
		marginTop: space.md,
	},
	dialogActionButton: {
		flexGrow: 1,
		flexBasis: 120,
	},
});
